import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSaleRoModel } from "../saleRoModel";
import { ISaleRoDetail } from "../saleRoTypes";
import { useDictModel } from "../../../../base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


type statusType = {
    "sale-return-status.settle": string,
    "sale-return-status.stock-io": string,
    "sale-return-status.create": string,
    "sale-return-status.change": string,
    [key: string]: any
}
export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        dataSource, selectedRowKeys, pgCfg, descRows,
        loadData, setSelectedRowKeys, setDescRows
    } = useSaleRoModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const statusColor: statusType = {
        "sale-return-status.settle": "blue",
        "sale-return-status.stock-io": "green",
        "sale-return-status.create": "geekblue",
        "sale-return-status.change": "red"
    }
    const columns: ColumnsType<ISaleRoDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '退货单号',/
            title: Locale["Sales Return Doc No."],
            width: 120,
            dataIndex: 'returnCode',
            fixed: "left",
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            width: 140,
            dataIndex: 'status',
            // render: (text) => <YhTag color={statusColor[getTreeNodeName(text)]} text={getTreeNodeName(text)} />,
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '支付状态',
            title: Locale["Payment status"],
            width: 160,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 160,
            ellipsis: true,
            dataIndex: 'createTime',
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 160,
            dataIndex: 'customerName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 160,
            dataIndex: 'contact',
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 160,
            dataIndex: 'phone',
        }, {
            // title: '退货数量',
            title: Locale["Return Qty"],
            width: 120,
            dataIndex: 'totalNum',
        }, {
            // title: '退货金额',
            title: Locale["Return Amount"],
            width: 120,
            dataIndex: 'totalAmount',
        }, {
            // title: '应付金额',
            title: Locale["Payable Amount"],
            width: 120,
            dataIndex: 'totalAmount',
        }, {
            // title: '已付金额',
            title: Locale["Paid Amount"],
            width: 120,
            dataIndex: 'amountReceived',
            // render: (text) => (Number(text) * 1.15).toFixed(2)
        }, {
            // title: '结算类型',
            title: Locale["Payment Type"],
            width: 160,
            dataIndex: 'payType',
            // render: (text) => `${getTreeNodeName(text)}`,
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '退货原因',
            title: Locale["Return Reason"],
            width: 160,
            dataIndex: 'returnReason',
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 160,
            dataIndex: 'createUser',
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            width: 160,
            dataIndex: 'storekeeper',
        }, {
            // title: '入库日期',
            title: Locale["Stock-in Time"],
            width: 160,
            ellipsis: true,
            dataIndex: 'stockIoTime',
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            width: 160,
            dataIndex: 'reckoner',
        }, {
            // title: '结算日期',
            title: Locale["Settle Time"],
            width: 160,
            ellipsis: true,
            dataIndex: 'settleTime',
        }, {
            // title: '核销时间',
            title: Locale["Write off time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'payTime',
        }, {
            // title: '打印次数',
            title: Locale["Print Times"],
            width: 160,
            dataIndex: 'printingTimes',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        },
    ];
    useEffect(() => {
        loadData().then();
    }, [])

    //点击行选高亮
    const onRow = (record: ISaleRoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: ISaleRoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 460 }}
        />
    )
}
